module.exports = __webpack_public_path__ + "static/media/tip_text_cat_topical_en.1541ed9b.svg";